import { jsx as _jsx } from "react/jsx-runtime";
import SearchIcon from '@heroicons/react/outline/SearchIcon';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { Input } from '@tribeplatform/react-ui-kit/Input';
import { useI18n } from '../i18n';
export const FilterBar = ({ setFilters }) => {
    const intl = useI18n();
    return (_jsx(Card, { children: _jsx(Card.Content, { children: _jsx(Input, { leadingIcon: _jsx(SearchIcon, {}, void 0), onChange: e => setFilters({ query: e.target.value || undefined }), name: "search", placeholder: intl.$t({
                    id: 'MemberList.FilterBar.SearchMembersPlaceholder',
                    defaultMessage: 'Search {MEMBERS}...',
                }) }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=FilterBar.js.map